import { Component, Inject, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { Util } from '../../../../../../utils/util';

@Component({
	selector: 'app-pix-qr-code-dynamic-modal-date',
	templateUrl: './modal-date.component.html',
	styleUrls: ['./modal-date.component.styl'],
})
export class PixQrCodeDynamicModalDateComponent implements OnInit {

	public date = new Date();
	public form: FormGroup;
	public minDate = new Date();
	public maxDate = Util.DateAddDay(30);
	public submited = false;

	constructor(
		public dialogRef: MatDialogRef<PixQrCodeDynamicModalDateComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any,
		private formBuilder: FormBuilder,
	) {
		this.date = new Date(data.date);
		console.log(data.date);
		console.log(this.date);
		this.minDate = data.date;
		this.maxDate = data.maxDate;
	}

	ngOnInit(): void {
		this.buildForm();
	}

	buildForm() {
		this.form = this.formBuilder.group({
			date: [this.date, Validators.required],
		});
	}

	onConfirm = () => {
		this.submited = true;
		if (this.form.valid) {
			this.dialogRef.close(this.form.get('date').value);
		}
	}

	onClose = () => this.dialogRef.close(false);
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/hmg-omni-internetbanking-deploy/src/app/master/pix/copy-and-paste/qr-code-dynamic/resume-final/modal-date/modal-date.component.ts